import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _JSXStyle from "styled-jsx/style";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useRef, useEffect } from 'react';
import { idFromPrefix } from '@@client/lib/forms';
import FormOnelinerGeneric from '@@client/components/FormOnelinerGeneric';
export var flexFormStyles = {
  input: {
    'font-size': '15px',
    'font-family': '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
    color: '#151824'
  }
};
export default function FormCybersourceField(_ref) {
  var idPrefix = _ref.idPrefix,
      id = _ref.id,
      children = _ref.children,
      microform = _ref.microform,
      microformFieldName = _ref.microformFieldName,
      placeholder = _ref.placeholder,
      _ref$onCreateFieldErr = _ref.onCreateFieldError,
      onCreateFieldError = _ref$onCreateFieldErr === void 0 ? function () {} : _ref$onCreateFieldErr,
      restAtts = _objectWithoutProperties(_ref, ["idPrefix", "id", "children", "microform", "microformFieldName", "placeholder", "onCreateFieldError"]);

  var name = microformFieldName;
  id = id || idFromPrefix(idPrefix, name);
  var ref = useRef(null);
  useEffect(function () {
    if (!microform || !ref.current) return;

    try {
      var field = microform.createField(microformFieldName, {
        placeholder: placeholder
      });
      field.load(ref.current);
    } catch (err) {
      onCreateFieldError(err);
    }
  }, [microform, ref.current]);
  return /*#__PURE__*/_jsxs(FormOnelinerGeneric, _objectSpread(_objectSpread({
    id: id,
    name: name
  }, restAtts), {}, {
    children: [/*#__PURE__*/_jsx("div", {
      id: id,
      ref: ref,
      className: "jsx-2694244165" + " " + 'cybersource-field'
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2694244165",
      children: [".cybersource-field.jsx-2694244165{height:41px;}"]
    })]
  }));
}